module.exports = "/_next/static/images/Frame2-302cab68f4d676cfc86415887d16f7bf.webp";